import React from 'react';
import { Divider, theme } from 'antd';

import './ChartCardDoubleLayout.css';

type ChartCardDoubleLayoutProps = {
  MainChart: React.ReactElement;
  SideChart: React.ReactElement;
};
function ChartCardDoubleLayout({ MainChart, SideChart }: ChartCardDoubleLayoutProps) {
  const { token } = theme.useToken();

  return (
    <div className="double-chart-layout">
      <div className="double-chart-layout__container">
        <div className="double-chart-layout__main-chart">
          <div style={{ marginRight: token.marginLG }}>{MainChart}</div>
        </div>
        <div className="double-chart-layout__divider--vertical">
          <Divider type="vertical" style={{ height: '100%' }} />
        </div>
        <div className="double-chart-layout__divider--horizontal">
          <Divider />
        </div>
        <div className="double-chart-layout__side-chart">
          <div style={{ marginLeft: token.marginLG, height: '100%' }}>{SideChart}</div>
        </div>
      </div>
    </div>
  );
}

export default ChartCardDoubleLayout;
